/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import * as React from 'react'
import {ReactNode} from 'react'
import '../../scss/global.scss'
import useValueTrackSaver from '../../hooks/useValueTrackSaver'
import Menu from '../menu'
import CallToAction from './CallToAction/CallToAction'
import Footer from './Footer/Footer'
import joinClassNames from '../../helpers/joinClassNames'
import useLayoutBanner from '../../hooks/useLayoutBanner'
import {isNull} from 'lodash'

type Props = {
    children: ReactNode
    showCallToAction?: boolean
    showNavigation?: boolean
}
const Layout = ({children, showCallToAction = true, showNavigation = true}: Props) => {
    useValueTrackSaver()
    const banner = useLayoutBanner()

    return (
        <>
            <Menu showNavigation={showNavigation} banner={banner} />
            <div id="content-wrapper" className={joinClassNames(!isNull(banner) && 'has-banner')}>
                <main>{children}</main>
                {!!showCallToAction && <CallToAction />}
                <Footer />
            </div>
        </>
    )
}

export default Layout
